export function removeDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
}

function getIndicesOf(searchStr, str, caseSensitive) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
        return [];
    }
    var startIndex = 0, index, indices = [];
    if (!caseSensitive) {
        str = str.toLowerCase();
        searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
        indices.push(index);
        startIndex = index + searchStrLen;
    }
    return indices;
}

function spliceSlice(str, index, add) {
    return str.slice(0, index) + add + str.slice(index);
}

export function processTibetan(text, style) {
    return text.replace(/[\u0F00-\u0FFF]+/gm, (match) => {
        return `<span style="${style}">${match}</span>`
    })
}

export function processTranslationToolIgnores(text, style) {
    return text.replace(/་\[(.*)\]/gm, (match, s1) => {
        return `<span style="${style}"><span style="font-size:0.7em">(</span>${s1}<span style="font-size:0.7em">)</span></span>`
    })
}

export function highlight(words, query, highlightClass, searchType) {
    if (!words || typeof words !== 'string') return words;

    query = query.replace(/"/g, "");

    let spanOpen = '<span class="'+highlightClass+'">';
    let spanClose = '</span>';

    if (searchType === 'definiendumRegex' || searchType === 'definiendum') {
        return words.replace(new RegExp(query, "g"), function (match) {
            return spanOpen+match+spanClose;
        });
    }
    else if (searchType === 'definiendumStarts') {
        return words.replace(new RegExp("^"+query, "gm"), function (match) {
            return spanOpen+match+spanClose;
        });
    }
    else if (searchType === 'definiendumLike') {
        query = query.replace(/_/, ".").replace(/%/, ".*");
        return words.replace(new RegExp(query, "g"), function (match) {
            return spanOpen+match+spanClose;
        });
    }
    else {
        let indices = getIndicesOf(removeDiacritics(query), removeDiacritics(words), false)
        let indexAcc = 0;
        let spanCloseLength = spanClose.length;
        let spanOpenLength = spanOpen.length;
        indices.forEach(index => {
            words = spliceSlice(words, index + indexAcc, spanOpen);
            indexAcc += spanOpenLength;
            words = spliceSlice(words, index + query.length + indexAcc, spanClose);
            indexAcc += spanCloseLength;
        });
        return words;
    }

}

export default {
    removeDiacritics,
    highlight,
    processTibetan,
    processTranslationToolIgnores
}
